/* @flow */
import { TOUCH_KEY as NAV_TOUCH_KEY } from 'components/NavigationList';
import { ActionTypes } from 'constants/RoleVerificationConstants';
import { touch } from 'actions/touchActions';
import { dispatcher } from 'lib/Dispatcher';

const RoleVerificationActions = {
  addRoleVerification(roleVerification: Object) {
    touch(NAV_TOUCH_KEY);
    dispatcher.dispatch({
      type: ActionTypes.ROLE_VERIFICATION_LOADED,
      roleVerification,
    });
  },
};

export default RoleVerificationActions;
